import { http } from "services/http";

import type {
  DepositsLimit,
  DepositsLimitUpdateRequest,
  DepositsLimitUpdateResponse,
} from "models/deposits-limit.model";

export const depositsLimitApi = {
  getDepositsLimit: () => http.quiet().post<DepositsLimit>("/api/get-deposit-limits"),
  depositsLimitUpdate: (data: DepositsLimitUpdateRequest) =>
    http.quiet().post<DepositsLimitUpdateResponse>("/api/get-deposit-limits/update", { ...data }),
};
